export const RoundingEntities = {
	RATE: {name: 'RATE', decimals: 4},
};

export default class RoundingUtility {
	static roundToNDecimals(value: number, decimalAmount: number): number {
		return Math.round((value + Number.EPSILON) * Math.pow(10, decimalAmount)) / Math.pow(10, decimalAmount);
	}

	static roundBasedOnEntityType(value: number, entityType: string): number {
		const entity = RoundingEntities[entityType];
		const decimalAmount = entity ? entity.decimals : 2;

		return this.roundToNDecimals(value, decimalAmount);
	}
}
